import { ReactElement } from 'react';

import { VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { useVisitSettlementUpdateMedicalServicesCommand } from '../../visitSettlement/shared/medicalServices/medicalServices.hooks';
import { visitActionBarTranslationKeys } from '../../translations';
import { useUpdateVisitCommand } from '../form/visitForm.hooks';
import { VisitFormController } from '../form/visitForm.types';

type PrescriptionVisitDataSaveAndCloseActionProps = {
   readonly controller: VisitFormController;
   readonly visitId: number;
   readonly appointmentId: number;
   readonly onClose: VoidFunction;
};

export const PrescriptionVisitDataSaveAndCloseAction = (
   props: PrescriptionVisitDataSaveAndCloseActionProps
): ReactElement => {
   const performingPrivateMedicalServicesAvailable = protectFeature('performingPrivateMedicalServices');

   const { executeAsync: updateVisit } = useUpdateVisitCommand(props.visitId);

   const updateVisitSettlementMedicalServices = useVisitSettlementUpdateMedicalServicesCommand({
      appointmentId: props.appointmentId,
      control: props.controller.control,
      blockingOperation: true,
   });

   const handleClick = props.controller.handleSubmit(async (values) => {
      await Promise.all([
         updateVisit(values),
         ...(performingPrivateMedicalServicesAvailable ? [updateVisitSettlementMedicalServices()] : []),
      ]);

      dispatchSnackbarPositiveEvent(visitActionBarTranslationKeys.prescriptionVisitData.changesSaved);

      await refetchCqrsQuery(VisitQuery);

      props.onClose();
   });

   return (
      <ModalConfirmButton
         testId={'saveAndClose'}
         label={visitActionBarTranslationKeys.confirmLater}
         onClick={handleClick}
         blockingOperation
      />
   );
};
